/** Ten minutes east-to-west, then ten minutes back; angles never go below ten degrees. */
export function sunAt(seconds: number) {
  const phase = ((seconds % 1200) + 1200) % 1200;
  const progress = phase <= 600 ? phase / 600 : (1200 - phase) / 600;
  const angle = ((10 + 160 * progress) * Math.PI) / 180;
  return { x: Math.cos(angle), y: Math.sin(angle), z: 0 };
}
